var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46825 5.11037L8.9427 6.58698C8.25418 8.5233 7.90992 9.49147 7.23057 10.198C6.55122 10.9045 5.62029 11.2625 3.75844 11.9786L2.33862 12.5252L3.75844 13.0718C5.62029 13.7878 6.55122 14.1469 7.23057 14.8524C7.90992 15.5578 8.25418 16.5271 8.9427 18.4634L9.46825 19.94L9.99381 18.4634C10.6823 16.5271 11.0276 15.5589 11.7059 14.8524C12.3843 14.1459 13.3162 13.7878 15.1781 13.0718L16.5979 12.5252L15.1781 11.9786C13.3162 11.2625 12.3853 10.9045 11.7059 10.198C11.0266 9.49147 10.6823 8.5233 9.99381 6.58698L9.46825 5.11037ZM16.6066 2.06006L16.3815 2.69244C16.0861 3.5229 15.9384 3.93813 15.6482 4.24001C15.3569 4.54296 14.9576 4.69655 14.1591 5.00268L13.551 5.23784L14.1601 5.47193C14.9576 5.77912 15.3569 5.93271 15.6471 6.2346C15.9384 6.53755 16.0861 6.95278 16.3805 7.78324L16.6066 8.41561L16.8317 7.78324C17.1271 6.95278 17.2747 6.53755 17.565 6.23566C17.8563 5.93271 18.2556 5.77912 19.0541 5.47299L19.6621 5.23784L19.0531 5.00374C18.2556 4.69655 17.8563 4.54296 17.566 4.24107C17.2747 3.93813 17.1271 3.5229 16.8327 2.69244L16.6066 2.06006Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.9561b83dcc8a30b77ecb13b48647bf0c.svg";
export { ForwardRef as ReactComponent };